import React from 'react';

export default function UnderConstructionPage({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="page-stack">
      <section className="card">
        <div className="hd">
          <div style={{ fontWeight: 760 }}>{title}</div>
          <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
            {description || 'Scaffolded for Phase 2. Navigation only for now.'}
          </div>
        </div>
        <div className="bd">
          <div className="muted">
            This module is intentionally not implemented in Phase 1.
          </div>
        </div>
      </section>
    </div>
  );
}
